import { render } from "./ProfileOfflineTab.vue?vue&type=template&id=d06f7252&scoped=true&ts=true"
import script from "./ProfileOfflineTab.vue?vue&type=script&lang=ts"
export * from "./ProfileOfflineTab.vue?vue&type=script&lang=ts"

import "./ProfileOfflineTab.vue?vue&type=style&index=0&id=d06f7252&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d06f7252"]])

export default __exports__